import clsx from 'clsx';
import { Fragment } from 'react';

import { games } from '@/modules/players/v2/tabs/overview/TournamentResults/constants';
import { getGameScores } from '@/modules/players/v2/tabs/overview/TournamentResults/utils';
import { PlayerLiveGameStatusData } from '@/types/players.types';

interface MobileScoresProps {
  match: PlayerLiveGameStatusData;
  userId: string;
}

const MobileScores = ({ match, userId }: MobileScoresProps) => {
  const gameScores = getGameScores(match, userId);
  const validGames = games
    .map((game, index) => ({
      game,
      score: gameScores[index] || { userScore: '', opponentScore: '' },
    }))
    .filter(({ score }) => score.userScore !== '' || score.opponentScore !== '');

  if (validGames.length === 0) return null;

  const medalWinnerRow =
    match.InBracketType === 'B' || match.InBracketType === 'GS' || match.InBracketType === 'GS2';

  return (
    <div
      className={clsx(
        'flex items-center justify-center border-b py-2 sm:hidden',
        medalWinnerRow ? 'border-white' : 'border-gray-200'
      )}
    >
      {validGames.map(({ game, score }, index) => {
        const firstScore = score.isTeamOne ? score.userScore : score.opponentScore;
        const secondScore = score.isTeamOne ? score.opponentScore : score.userScore;

        const isEqual = parseInt(firstScore) === parseInt(secondScore);
        const isFirstWinning = parseInt(firstScore) > parseInt(secondScore);

        return (
          <Fragment key={game}>
            <div className='flex flex-col items-center justify-center'>
              <p className='text-xs text-gray-900'>{game}</p>
              {score.forfeitMessage ? (
                <p className='text-lg text-gray-900'>{score.forfeitMessage}</p>
              ) : (
                <div className='flex text-lg'>
                  <p
                    className={
                      isEqual
                        ? 'text-gray-900'
                        : isFirstWinning
                          ? 'text-green-600'
                          : 'text-gray-900'
                    }
                  >
                    {firstScore}
                  </p>
                  <span className='mx-0.5'>-</span>
                  <p
                    className={
                      isEqual
                        ? 'text-gray-900'
                        : !isFirstWinning
                          ? 'text-green-600'
                          : 'text-gray-900'
                    }
                  >
                    {secondScore}
                  </p>
                </div>
              )}
            </div>
            {index < validGames.length - 1 && <span className='mx-3 h-[14px] w-0.5 bg-gray-300' />}
          </Fragment>
        );
      })}
    </div>
  );
};

export default MobileScores;
